export const capitalize = (value: string): string => {
  if (!value) {
    return value;
  }

  return value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};
